import { OnboardingLocal, LOCAL_PAR_DEFAUT } from './types';

// Le suffixe par identifiant utilisateur est OBLIGATOIRE :
// ParameterScreen.handleLogout ne supprimait que la clé 'user', laissant tout le
// reste au compte suivant qui se connecte sur le même navigateur.
const PREFIXE = 'vm_onboarding_v1_';

// Préfixes purgés à la déconnexion et à la suppression de compte.
const PREFIXES_A_PURGER = ['vm_onboarding_', 'vm_voyageur_'];

const cle = (idUtilisateur: number | string) => `${PREFIXE}${idUtilisateur}`;

export const lireOnboarding = (idUtilisateur: number | string): OnboardingLocal => {
  try {
    const brut = localStorage.getItem(cle(idUtilisateur));
    if (!brut) return { ...LOCAL_PAR_DEFAUT };
    const objet = JSON.parse(brut);
    // Une version inconnue est repartie de zéro plutôt que fusionnée à l'aveugle.
    if (!objet || objet.version !== 1) return { ...LOCAL_PAR_DEFAUT };
    return {
      ...LOCAL_PAR_DEFAUT,
      ...objet,
      celebrations: { ...LOCAL_PAR_DEFAUT.celebrations, ...(objet.celebrations || {}) },
    };
  } catch (e) {
    return { ...LOCAL_PAR_DEFAUT };
  }
};

/** Écriture SYNCHRONE : les verrous anti-rejeu des célébrations en dépendent. */
export const ecrireOnboarding = (
  idUtilisateur: number | string,
  patch: Partial<OnboardingLocal>
): OnboardingLocal => {
  const courant = lireOnboarding(idUtilisateur);
  const suivant: OnboardingLocal = { ...courant, ...patch, version: 1 };
  try {
    localStorage.setItem(cle(idUtilisateur), JSON.stringify(suivant));
  } catch (e) {
    // Quota dépassé ou stockage désactivé : l'onboarding doit rester utilisable.
    console.warn('Onboarding : écriture locale impossible.', e);
  }
  return suivant;
};

export const initOnboardingLocal = (idUtilisateur: number | string): OnboardingLocal =>
  ecrireOnboarding(idUtilisateur, {});

/** Appelée à la déconnexion et à la suppression de compte. */
export const purgerOnboarding = (): void => {
  try {
    const aSupprimer: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && PREFIXES_A_PURGER.some((p) => k.startsWith(p))) aSupprimer.push(k);
    }
    aSupprimer.forEach((k) => localStorage.removeItem(k));
    sessionStorage.removeItem('vm_voyageur_brouillon');
    sessionStorage.removeItem('formState');
  } catch (e) {
    console.warn('Onboarding : purge locale impossible.', e);
  }
};
